export default class PaNotifyController {
  static list (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paNotify/list', 'post', params, axiosOption, httpOption);
  }

  static view (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paNotify/view', 'get', params, axiosOption, httpOption);
  }

  static export (sender, params, fileName) {
    return sender.download('/admin/app/paNotify/export', params, fileName);
  }

  static add (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paNotify/add', 'post', params, axiosOption, httpOption);
  }

  static update (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paNotify/update', 'post', params, axiosOption, httpOption);
  }

  static delete (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paNotify/delete', 'post', params, axiosOption, httpOption);
  }

  static addLines (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paNotify/addLines', 'post', params, axiosOption, httpOption);
  }
}
